export default __webpack_public_path__ + "static/media/santa-maria-2.b97ac15f.jpg";